import LayoutActividad from "../../../components/LayoutActividad";
import { modulo12 } from "../../../routes/Module12";
import Sidebar from "../Sidebar";
import Imagen1 from "../../../images/modulo12/compas.png";
import Imagen2 from "../../../images/modulo12/aguacerro.png";
import GuiaDocente from "../../../components/GuiaDocente";

const Actividad1 = () => {
  const infoUnidad = modulo12.content[1];
  const infoAct = modulo12.content[1].activities[2];
  const crumbs = [
    {
      title: modulo12.title,
      url: "/" + modulo12.url,
    },
    {
      title:
        modulo12.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo12.content[1].name}: ${modulo12.content[1].activities[3].name}`,
    linkNext: `${modulo12.url}/${modulo12.content[1].path}/${modulo12.content[1].activities[3].path}`,
    titlePrev: `${modulo12.content[1].name}: ${modulo12.content[1].activities[1].name}`,
    linkPrev: `${modulo12.url}/${modulo12.content[1].path}/${modulo12.content[1].activities[1].path}`,
  };
  const metadata = {
    color: modulo12.color,
    title: `${modulo12.title} - ${infoAct.name}`,
    name: modulo12.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <h2 className="mb-5">{infoAct.name}</h2>

      <div className="bg-light p-3 p-md-5">
        <h2>¿Todos tenemos lo mismo?</h2>
        <div className="row mt-3 align-items-center">
          <div className="col-md-8 col-12 p-4 p-md-3">
            <p>
              En el Perú, algunos tienen mucho y otros tienen muy poco. Eso se
              llama{" "}
              <strong>desigualdad</strong>. La desigualdad ha existido siempre
              en nuestro país.
            </p>
            <p>
              Cuando tienes dinero es más fácil obtener <strong>bienes</strong>:
              una casa, un carro, ropa. También es más fácil acceder a buenos
              servicios: educación, salud, alimentación.
            </p>
          </div>
          <div className="col-md-4 col-12 text-center">
            <img src={Imagen1} className="img-fluid" alt="Peruanos" />
          </div>
          <div className="col-md-4 col-12 text-center">
            <img src={Imagen2} className="img-fluid" alt="Peruanos" />
          </div>
          <div className="col-md-8 col-12 p-4 p-md-5">
            <p>
              Cuando las familias no tienen dinero y otros recursos, la vida es
              más complicada para ellos. Algunas personas, por ejemplo, deben
              dedicar varias horas diarias a conseguir agua.
            </p>
            <p>
              El Estado debería garantizar el acceso de toda la población a
              servicios de calidad.
            </p>
          </div>
        </div>
      </div>

      <GuiaDocente>
        <li>Lea el texto ¿Todos tenemos lo mismo?</li>

        <li>
          Explique a los niños y niñas que, en el Perú, a pesar del crecimiento
          económico, sigue habiendo desigualdad entre las personas, es decir,
          existen personas que no pueden acceder a una serie de recursos o
          servicios de calidad. Como ejemplo de ello, recuerde las situaciones
          vistas: los casos de acceso al servicio de salud de Brayan y Mario o
          la situación de Elmer Puémape, quien no puede matricular a su hijo en
          la escuela. Mencione que la desigualdad será el tema de la unidad.
        </li>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad1;
